import React from "react";

export default (props) => {
  return (
    <React.Fragment>
      <p>You cannot submit your chosen evidence via MyScan. You will need to take the original documentation to any of
        the following sites so that a member of staff can check and verify.</p>
      <p>
        The Britwell Centre<br/>
        Wentworth Avenue<br/>
        Britwell<br/>
        SL2 2DS<br/>
        <a href="https://goo.gl/maps/AVXYFST9SdAhtt9N9" rel="noreferrer" target="_blank">Get directions (opens in Google Maps)</a>
      </p>

      <p>
        Langley Library<br/>
        Trelawney Avenue<br/>
        Langley<br/>
        SL3 7UF<br/>
        <a href="https://goo.gl/maps/aAiRnpdZY6Z4V4Ja9" rel="noreferrer" target="_blank">Get directions (opens in Google Maps)</a>
      </p>

      <p>
        Cippenham Library<br/>
        Elmshott Lane<br/>
        Cippenham<br/>
        Slough<br/>
        SL1 5RB<br/>
        <a href="https://goo.gl/maps/R4LCWmFQAWGNdmGd7" rel="noreferrer" target="_blank">Get directions (opens in Google Maps)</a>
      </p>

      <p>Chalvey Community Hub<br/>
        Ladbrooke Road<br/>
        Slough<br/>
        SL1 2SR<br/>
        <a href="https://goo.gl/maps/WegVo6TqFZvBSnUg7" rel="noreferrer" target="_blank">Get directions (opens in Google Maps)</a>
      </p>
      <br/>
      <p>
        Please refer to our website for opening hours - <a href="https://www.slough.gov.uk/directory/1/council-buildings/category/6" rel="noreferrer" target="_blank">Community hubs – Slough Borough Council</a>
      </p>

      <br/>
    </React.Fragment>);
}
